import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Text,
  chakra,
  useBreakpoint,
} from "@highoutput/ui-components";
import { useRouter } from "next/router";
import { InView } from "react-intersection-observer";
import { ArrowRight } from "../free-coaching/icon";
import For from "../utilities/for";

const mock = [
  "Discover your goal outcomes with the help of our expert coaches.",
  "Create a plan of action to achieve your goals with guidance and support.",
  "Receive a personalized report of your coaching assessments and action plans, three days after your sessions.",
];

const CampaignHeader = () => {
  const breakpoint = useBreakpoint();
  const router = useRouter();
  return (
    <InView triggerOnce delay={200}>
      {({ ref, inView }) => (
        <Flex
          ref={ref}
          direction={{
            base: "column",
            xl: "row",
          }}
          alignItems="center"
          bg="rgba(240,237,236,0.2)"
          pt={{ base: "3rem", lg: "4rem", xl: 0 }}
          justifyContent={{ xl: "flex-start", "2xl": "center" }}
          overflow="hidden"
          px={{ base: "1rem", lg: 0 }}
          sx={{
            opacity: 0,
            transform: "translateY(10vh)",
            transition: "transform 600ms ease-out, opacity 600ms ease-out",
            willChange: "transform, opacity",
            ...(inView && {
              opacity: 1,
              transform: "none",
            }),
          }}
          gap={{ base: 0, xl: 20 }}
        >
          <Box
            w={{ lg: "auto", xl: 552 }}
            h={{ base: 240, lg: 420, xl: 1056 }}
            display={{ base: "none", xl: "block" }}
          >
            <Image
              ref={ref}
              src="images/campaign/campaign-header.webp"
              alt="header"
              loading="lazy"
              objectFit="cover"
              w={{ base: 370, lg: 960, xl: "100%" }}
              h={{ base: 240, lg: 420, xl: 1056 }}
            />
          </Box>
          <Box w={{ lg: "auto", xl: 720 }} px={{ lg: "24px", xl: 0 }}>
            <Heading
              variant={{ base: "32/36", lg: "40/44" }}
              color="rgb(13,48,80)"
              mb={{ base: "24px", lg: "2rem" }}
              fontWeight={500}
              letterSpacing="-0.02em"
            >
              Looking for professional and personal growth? Sign up for our
              <chakra.span color="rgb(13,48,80)"> free coaching sessions </chakra.span> to
              <br style={{ display: breakpoint !== "base" ? "none" : "block" }} /> get started!
            </Heading>
            <Box color="rgba(13,48,80,0.8)" fontFamily="'Inter', sans-serif">
              <Box w={{ lg: "unset", xl: "648px" }}>
                <Text variant={{ base: "18/28", lg: "24/36" }} pb="10px">
                  Our coaching sessions have been designed to help career professionals achieve
                  their goals and aspirations. Our team of experienced coaches are committed to
                  helping you identify the barriers that are holding
                  <br style={{ display: breakpoint !== "xl" ? "none" : "block" }} /> you back.
                </Text>
              </Box>

              <Flex my={{ base: "1rem" }} direction="column" gap={"16px"}>
                <For each={mock}>
                  {(text, i) => (
                    <>
                      <Flex key={i} alignItems={{ base: "flex-start", lg: "center" }}>
                        <Box mt="6px" mr="12px">
                          <Icon as={ArrowRight} />
                        </Box>
                        <Box w={{ lg: "unset", xl: "80%" }}>
                          <Text variant={{ base: "18/28", lg: "24/36" }} color="rgba(13,48,80,0.8)">
                            {text}
                          </Text>
                        </Box>
                      </Flex>
                    </>
                  )}
                </For>
              </Flex>

              <Text
                variant={{ base: "18/28", lg: "24/36" }}
                pt={{ base: "10px", lg: "2rem", xl: "3rem" }}
              >
                Limited slots only. Sign up now!
              </Text>
            </Box>

            <Flex direction={{ base: "column", lg: "row" }} height={20}>
              <Box my="1rem">
                <Button
                  w={{ base: "full", lg: "unset" }}
                  size="lg"
                  width="full"
                  fontFamily="'Inter', sans-serif"
                  color="rgb(13,48,80)"
                  bgColor={"primary.light"}
                  onClick={() => router.push("https://calendly.com/advante/free-coaching")}
                >
                  Choose your schedule
                </Button>
              </Box>
            </Flex>
          </Box>

          <Box
            w={{ lg: "auto", xl: 720 }}
            h={{ base: 240, lg: 420, xl: 960 }}
            display={{ base: "block", xl: "none" }}
            mt={{ base: "1.5rem", lg: "2.5rem" }}
          >
            <Image
              ref={ref}
              src={
                breakpoint === "lg"
                  ? "images/campaign/campaign-header-2.webp"
                  : "images/campaign/campaign-header-3.webp"
              }
              alt="header-tab"
              loading="lazy"
              objectFit="cover"
              w={{ base: 370, lg: 960, xl: "100%" }}
              h={{ base: 240, lg: 420, xl: 960 }}
            />
          </Box>
        </Flex>
      )}
    </InView>
  );
};

export default CampaignHeader;
